import { ReactElement, useState } from 'react';
import { Tooltip, Typography } from '@getgo/chameleon-web-react-wrapper/register';
import { v4 } from 'uuid';
import styles from './JobStatusProgressCellRenderer.module.scss';
import { Trans } from 'react-i18next';
import { JobStatusProgressCellRendererProps } from '../../../types/frontend/cell-renderers/JobStatusCellRenderer.types';
import { JobStatusProgressBar } from './JobStatusProgressBar';

export function JobStatusProgressCellRenderer({
  jobRunStatistics,
  jobStatus,
  isNewJob
}: JobStatusProgressCellRendererProps): ReactElement {
  const [componentId] = useState<string>(v4());

  return (
    <div id={componentId} className={styles.container}>
      <Tooltip triggerId={componentId}>
        <Typography variant={'caption-medium'}>
          {jobRunStatistics ? (
            <>
              <strong>
                <Trans
                  i18nKey="tooltips.jobRunStatistics.total"
                  values={{ count: jobRunStatistics.totalUpdateCount }}
                />
              </strong>
              {!isNaN(jobRunStatistics.successfulUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.successful"
                    values={{ count: jobRunStatistics.successfulUpdateCount }}
                  />
                </>
              )}
              {isNewJob && !isNaN(jobRunStatistics.restartRequiredUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.restartRequired"
                    values={{ count: jobRunStatistics.restartRequiredUpdateCount }}
                  />
                </>
              )}
              {!isNaN(jobRunStatistics.failedUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.failed"
                    values={{ count: jobRunStatistics.failedUpdateCount }}
                  />
                </>
              )}
              {!isNaN(jobRunStatistics.cancelledUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.cancelled"
                    values={{ count: jobRunStatistics.cancelledUpdateCount }}
                  />
                </>
              )}
              {!isNaN(jobRunStatistics.inProgressUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.inProgress"
                    values={{ count: jobRunStatistics.inProgressUpdateCount }}
                  />
                </>
              )}
              {isNewJob && !isNaN(jobRunStatistics.pendingUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.pending"
                    values={{ count: jobRunStatistics.pendingUpdateCount }}
                  />
                </>
              )}
              {!isNaN(jobRunStatistics.scheduledUpdateCount) && (
                <>
                  <br />
                  <Trans
                    i18nKey="tooltips.jobRunStatistics.scheduled"
                    values={{ count: jobRunStatistics.scheduledUpdateCount }}
                  />
                </>
              )}
            </>
          ) : (
            <Trans i18nKey="tooltips.noJobRunStatistics" />
          )}
        </Typography>
      </Tooltip>
      <JobStatusProgressBar jobStatus={jobStatus} jobRunStatistics={jobRunStatistics} isNewJob={isNewJob} />
    </div>
  );
}
